// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2h_U4","colBig":"styles_colBig__1GMlr","colSmall":"styles_colSmall__1Ifly"};